import SOM_4 from "url:../sfx/huuoop.m4a";
import MONSTRO_4 from "url:../sprites/boboleia.png";

export default {
  attack: 1,
  life: 30,
  speed: 1,
  agility: 2,
  image: MONSTRO_4,
  sound: SOM_4,
};
